/* Renais: routes the new theme's add-to-cart forms through live's cart system
   (legacy-cart.js + legacy-minicart section) so the drawer, free-gift chooser,
   auto-add rules and upsells behave exactly as on the live theme. */
(function () {
  function isAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var action = (form.getAttribute('action') || '').split('?')[0].split('#')[0];
    return /\/cart\/add$/.test(action);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isAddForm(form)) return;
    var cart = window.CartController;
    if (!cart || typeof cart.addItems !== 'function') return; // fall back to a normal form post
    event.preventDefault();
    event.stopImmediatePropagation();

    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    var data = new FormData(form);
    var id = data.get('id');
    if (!id) { if (submit) submit.disabled = false; return; }
    var quantity = parseInt(data.get('quantity') || '1', 10) || 1;
    var properties = {};
    data.forEach(function (value, key) {
      var m = key.match(/^properties\[(.*)\]$/);
      if (m && value !== '') properties[m[1]] = value;
    });
    var item = { id: id, quantity: quantity, properties: properties };
    var plan = data.get('selling_plan');
    if (plan) item.selling_plan = plan;
    var items = [item];

    Promise.resolve(
      typeof cart.appendTriggerGiftItems === 'function'
        ? cart.appendTriggerGiftItems(String(id), quantity, items)
        : null
    )
      .then(function () { return cart.addItems(items, true); })
      .catch(function (error) { console.error('ProductForm.addToCart:', error); })
      .then(function () { if (submit) submit.disabled = false; });
  }, true);

  // Header cart link opens the drawer, as on live. Falls back to /cart without JS.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.rn-hdr a.cart');
    if (!link || !window.Minicart || !document.querySelector('[data-minicart-drawer]')) return;
    event.preventDefault();
    window.Minicart.openDrawer();
  });

  // Close the drawer when the page overlay is clicked or Escape is pressed.
  document.addEventListener('click', function (event) {
    var drawer = document.querySelector('[data-minicart-drawer]');
    if (!drawer || !drawer.classList.contains('is-open') || !window.Minicart) return;
    if (drawer.contains(event.target) || (event.target.closest && event.target.closest('.rn-hdr a.cart'))) return;
    window.Minicart.closeDrawer();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && window.Minicart) window.Minicart.closeDrawer();
  });

  // Keep the header count in step with the cart.
  function syncCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.rn-hdr a.cart').forEach(function (a) {
          a.textContent = c.item_count > 0 ? 'Cart (' + c.item_count + ')' : 'Cart';
        });
      })
      .catch(function () {});
  }
  ['itemsAddedToCart', 'cartUpdated', 'cartItemRemoved', 'minicartReloaded'].forEach(function (name) {
    document.addEventListener(name, syncCount);
  });
})();
